/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPermissionsResponse } from '../../models/get-permissions-response';
import { PermissionTypeEnum } from '../../models/permission-type-enum';

export interface GetContentPermissions$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * typ oprávnenia (PRODUCT/COMPANY)
 */
  permissionType?: PermissionTypeEnum;
}

export function getContentPermissions(http: HttpClient, rootUrl: string, params: GetContentPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getContentPermissions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('permissionType', params.permissionType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPermissionsResponse>;
    })
  );
}

getContentPermissions.PATH = '/admin/content/{id}/permissions';
